<template>
  <app-layout>
    <MediaManager />
  </app-layout>
</template>
<script>
  import MediaManager from '../components/MediaManager/MediaManager.vue';
  export default {
    components: {
      MediaManager
    }
  }
</script>
